import { AssessmentAPI, AssignmentAPI, AssignmentGradingAPI } from '@oneapp/main/core/assessment/assessment.models';
import { StateSliceDefaults, StateSliceName } from '@oneapp/main/core/store.models';
import { UserAPI, UserForSportAPI } from '@oneapp/main/core/user/user.models';

export enum AssignmentsTableColumn {
    USERNAME = 'name',
    ASSESSMENT = 'assessment',
    DATE_ASSIGNED = 'dateAssigned',
    SCORING_POLICY = 'scoringPolicy',
    TYPE = 'type',
    STATUS_AND_SCORE = 'score',
    CTA = 'cta'
}

export interface AssignmentTableRow {
    [AssignmentsTableColumn.USERNAME]: string;
    [AssignmentsTableColumn.ASSESSMENT]: {
        id: string;
        name: string;
        description: string | undefined;
    };
    [AssignmentsTableColumn.DATE_ASSIGNED]: string;
    [AssignmentsTableColumn.SCORING_POLICY]: string;
    [AssignmentsTableColumn.TYPE]: string;
    [AssignmentsTableColumn.STATUS_AND_SCORE]: {
        status: string;
        score: undefined | number;
    };
    [AssignmentsTableColumn.CTA]: {
        completedOn: string | null;
        startedOn: string | null;
        canComplete: boolean;
        canStart: boolean;
        assignmentId: string;
    };
}

export enum AssignmentFormControlName {
    PARTNER = 'partner',
    USER = 'user',
    ASSESSMENT_DEF = 'assessment-def',
    ASSESSMENT_TYPE = 'assessment-type',
    SCORING_POLICY = 'scoring-policy',
    STATUS = 'status',
    SPORT = 'sport'
}

export type AssignmentFilterValues = Partial<Record<AssignmentFormControlName, string>>;

export const DEFAULT_FILTER_VALUE = 'default';

export const DEFAULT_FILTER_VALUES: AssignmentFilterValues = {
    /** Partner is undefined because 'All Partners' is not an option. */
    [AssignmentFormControlName.PARTNER]: DEFAULT_FILTER_VALUE,
    [AssignmentFormControlName.USER]: DEFAULT_FILTER_VALUE,
    [AssignmentFormControlName.ASSESSMENT_DEF]: DEFAULT_FILTER_VALUE,
    [AssignmentFormControlName.ASSESSMENT_TYPE]: DEFAULT_FILTER_VALUE,
    [AssignmentFormControlName.SCORING_POLICY]: DEFAULT_FILTER_VALUE,
    [AssignmentFormControlName.STATUS]: DEFAULT_FILTER_VALUE
};

export interface AssignedAssessmentsStateModel {
    assignments: AssignmentAPI[] | undefined;
    /** Assessment definitions by ID */
    assessmentDefinitions: Record<string, AssessmentAPI> | undefined;
    filters: AssignmentFilterValues | undefined;
    users: UserAPI[] | undefined;
    scorecardAssignment: AssignmentAPI | undefined;
    scorecardAssessment: AssessmentAPI | undefined;
    scorecardAssignmentGrading: AssignmentGradingAPI | undefined;
    scorecardUser: UserForSportAPI | undefined;
}

export const assignedAssessmentsStateDefaults: StateSliceDefaults<AssignedAssessmentsStateModel> = Object.freeze({
    sliceName: StateSliceName.ASSIGNED_ASSESSMENTS,
    defaults: {
        assignments: undefined,
        assessmentDefinitions: undefined,
        filters: undefined,
        users: undefined,
        scorecardAssignment: undefined,
        scorecardAssessment: undefined,
        scorecardAssignmentGrading: undefined,
        scorecardUser: undefined
    }
});
